import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getAsset } from '../../../../../../../../util/assets';
import getConfig from '../../../../../../../../util/config';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import { ALBUM_TYPE } from '../../../../../../../../constants/albums';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../../constants/event-items';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};

const AccountMarketingMaterialShareQR = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const url = (() => {
    if (albumFolder.auto_contributor_share_url) {
      return albumFolder.auto_contributor_share_url;
    }

    if (albumFolder.album_type === ALBUM_TYPE.EVENT) {
      return `${getConfig().app.baseUrl}/s/event-invite/${albumFolder.id}`;
    }

    return albumFolder.is_web_gallery
      ? `${getConfig().app.baseUrl}/galleries/view/folder/${albumFolder.id}`
      : albumFolder.onboarding_short_url;
  })();

  const includeWatermark =
    !albumFolder?.purchased_event?.features
      ?.white_label_marketing_prints_enabled &&
    !albumFolder?.purchased_event_addon_types?.includes(
      EVENT_ADDON_ITEM_TYPE.WALDOFIED,
    ) &&
    // Covers Memory Book / GV
    !(
      albumFolder?.individual_albums &&
      albumFolder?.purchased_event_addon_types?.length > 0
    );

  return (
    <div ref={templateRef} className="marketing-material-share-qr-template">
      <QRCode
        renderAs="canvas"
        value={getUtmParamsForQrCodeUrl({ url, albumFolder })}
        size={width * 0.8 ?? 400}
      />

      {includeWatermark && (
        <img
          className="waldo-powered-by-logo"
          src={getAsset('/powered-by-waldo-blue.svg')}
          alt=""
        />
      )}
    </div>
  );
};

AccountMarketingMaterialShareQR.propTypes = propTypes;

export default AccountMarketingMaterialShareQR;
